import React from 'react'

import './EstilosViews.scss';

type Props = {}

const Conocenos = (props: Props) => {

    var tituloSeccion: string = "Conocenos";

    return (
        <section className="page-section bg-primary text-white mb-0" id="conocenos">

            <div className="container">

                <h2 className="page-section-heading text-center text-uppercase text-white">{ tituloSeccion }</h2>

                <div className="divider-custom divider-light">
                    <div className="divider-custom-line"></div>
                    <div className="divider-custom-icon">
                        <i className="fa-solid fa-user"></i>
                    </div>
                    <div className="divider-custom-line"></div>
                </div>

                <div className="row">
                    <div className="col-lg-4 ms-auto">
                        <p className="lead textoJustificado">
                            El Albergue es ideal para desconectar en familia o con amigos y gracias a nuestra altura también es perfecto para realizar entrenamientos de elite.
                        </p>
                    </div>
                    <div className="col-lg-4 me-auto">
                        <p className="lead textoJustificado">
                            La zona común ofrece varias mesas y un rincón acogedor para descansar, desde donde puedes observar la Dehesa y la Muela de San Juan, a través de unos enormes ventanales.
                        </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-4 ms-auto">
                        <p className="lead textoJustificado">
                            Cuenta con 60 plazas distribuidas en habitaciones dobles y habitaciones compartidas, todas ellas cuentan con baño privado, sabanas y toallas.
                        </p>
                    </div>
                    <div className="col-lg-4 me-auto">
                        <p className="lead textoJustificado">
                            Se ofrece el servicio de desayunos y media pensión (desayuno y cena), que se pueden degustar en el interior o en su terraza con vistas a los bosques de los Montes Universales.
                        </p>
                    </div>
                </div>

                <div className='row mt-3 mb-3 contenedorFramesVideos'>
                    <iframe className='frameVideosVertical' src="https://www.youtube.com/embed/0qWfb2eAT8A" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                </div>

                <div className="divider-custom divider-light">
                    <div className="divider-custom-line divider-custom-line2"></div>
                </div>

                <div className='row mt-3 mb-3'>
                    <img src='./img/sections/con1.jpg' className='conocenos' alt='Adriana y Javi'/>
                </div>

                <div className='row'>
                    <div className="col-lg-4 ms-auto">

                        <p className="lead textoJustificado">
                            Nuestros nombres son Javier y Adriana, los actuales regentes del Albergue de Griegos, somos una pareja de jóvenes emprendedores con ganas de llevar a cabo esta aventura con el objetivo de luchar por nuestro territorio vaciado.
                        </p>

                    </div>

                    <div className="col-lg-4 me-auto">

                        <p className="lead textoJustificado">
                            Somos descendientes de familias del pueblo vecino de Guadalaviar y del propio pueblo de Griegos, así que conocemos el potencial que tiene esta zona para disfrutarla.
                        </p>

                    </div>

                </div>

                <div className='row'>
                    <div className="col-lg-8 me-auto ms-auto">
                        <p className="lead textoJustificado">
                            Nos embarcamos en esta aventura a principios de junio de 2022, con intención de dar a conocer la Sierra de Albarracín y sobre todo los alrededores de Griegos, Guadalaviar y Villar del Cobo.
                        </p>
                    </div>
                </div>

            </div>

        </section>
    )
}

export default Conocenos